<script setup lang="ts"></script>
<template>
  <div class="h-screen bg-white dark:bg-indigo-950">
    <!-- <HomeView /> -->
    <RouterView />
  </div>
</template>

<style scoped></style>
